import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchProcessLineSteps(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/show_process/${packing_house_process_id}/fetch_process_line_steps`
    );
  },
};
